import * as React from 'react';

import DirectoryFiltersName from './directory-filters-name';
import DirectoryFiltersBusiness from './directory-filters-business';
import DirectoryFiltersCategory from './directory-filters-category';

interface IDirectoryFilters {
  selectedNameFilter: string;
  selectedBusinessFilter: string;
  selectedCategoryFilter: string;
  categoryList: Array<string>;
}

export default class DirectoryFilters extends React.Component<IDirectoryFilters, any>{

  render(){

    return (
      <div className="affiliate-filters-display" id="filters-container">
        <div className="affiliate-filters">
          <DirectoryFiltersName selectedNameFilter={this.props.selectedNameFilter} />
          <DirectoryFiltersBusiness selectedBusinessFilter={this.props.selectedBusinessFilter} />
          <DirectoryFiltersCategory categoryList={this.props.categoryList} selectedCategoryFilter={ this.props.selectedCategoryFilter } />
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/filters/directory-filters.tsx